import { BayHeadingEnum } from "./shared/Enums/bay-heading-enum";
export class BaysConstants {
    static Headings = {
        PageHeadings: "Bays"
    };
}
export const BaysHeadingEnumHeadingLookup = new Map([
    [BayHeadingEnum.tradingSiteDescription, "tradingSiteDescription"],
    [BayHeadingEnum.tradingSiteTown, "tradingSiteTown"],
    [BayHeadingEnum.tradingSiteStatus, "tradingSiteStatus"],
    [BayHeadingEnum.size, "size"],
    [BayHeadingEnum.status, "status"]
]);
